<template>
	<div class="position-fixed" style="bottom: 1rem; right: 1rem;z-index:9999" v-if="alertTemp.length > 0">
		<div class="toast show mt-2" role="alert" aria-live="assertive" aria-atomic="true" v-for="alert in alertTemp" :key="alert.id">
			<div class="toast-header opacity-75" :class="['bg-' + alert.color, 'text-' + alert.textColor]">
				<strong class="me-auto">{{ alert.title }}</strong>
				<button type="button" class="btn-close" @click.prevent="closeToast(toast)"></button>
			</div>

			<div class="toast-body">
				{{ alert.message }}
			</div>
		</div>
	</div>
</template>

<script setup>
import usePublic from "~/store/Public";
const alertTemp = computed({
	get() {
		return usePublic().AlertList;
	},
});
</script>
